module.exports = __webpack_public_path__ + "static/media/random.c9cbed7c.svg";